/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-11 11:58:07
 */

import Mock from 'mockjs'

import login from './modules/login'
import waitDoing from './modules/workbench.js'
import progressManage from './modules/progressManege'
import judge from './modules/propleManage/judge'
import organizerWorkbench from './modules/organizerWorkbench'
import taskInfo from './modules/taskInfo'
const mocks = [...login, ...waitDoing, ...progressManage, ...organizerWorkbench, ...taskInfo, ...judge]
Mock.setup({
  timeout: 1000
})
mocks.forEach(value => {
  Mock.mock(new RegExp(value.path), value.type, config => {
    if (typeof value.response === 'function') {
      return value.response(config)
    } else {
      return value.response
    }
  })
})



// WEBPACK FOOTER //
// ./src/mocks/index.js